import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: number;
  forceShow?: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = 'top',
  maxWidth,
  forceShow = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isVisible = forceShow || isHovered;

  const getPositionStyles = () => {
    const baseStyles = {
      position: 'absolute' as const,
      zIndex: 2000,
      backgroundColor: '#333',
      color: 'white',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      whiteSpace: maxWidth ? ('normal' as const) : ('nowrap' as const),
      maxWidth: maxWidth ? `${maxWidth}px` : undefined,
      minWidth: maxWidth ? `${Math.min(maxWidth, 200)}px` : undefined,
      wordWrap: maxWidth ? ('break-word' as const) : undefined,
      pointerEvents: 'none' as const,
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.2s ease-in-out',
    };

    switch (position) {
      case 'top':
        return {
          ...baseStyles,
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '4px',
        };
      case 'bottom':
        return {
          ...baseStyles,
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginTop: '4px',
        };
      case 'left':
        return {
          ...baseStyles,
          right: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginRight: '4px',
        };
      case 'right':
        return {
          ...baseStyles,
          left: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginLeft: '4px',
        };
      default:
        return baseStyles;
    }
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      <div style={getPositionStyles()}>{content}</div>
    </div>
  );
};
